<template>
	<div id="app-wrapper" class="bg-back-white">
		<RouterView />
	</div>
</template>

<script>
import { RouterView } from 'vue-router';

import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';

export default {
	name: 'App',
	components: {
		RouterView,
	},
	mounted() {
		// send different events based on window width to track device type
		const width = window.innerWidth;
		if (width < 768) {
			logEvent(analytics, 'mobile_view', {
				width,
			});
		} else if (width < 1024) {
			logEvent(analytics, 'tablet_view', {
				width,
			});
		} else {
			logEvent(analytics, 'desktop_view', {
				width,
			});
		}
	},
}
</script>
